export class EmpSkillMatrix {
    employeeId? : number;
    employeeName?:string;
    plant?:string
    constructor(plant?: string,employeeId?: number,employeeName?: string, ){
        this.plant = plant
        this.employeeId = employeeId
        this.employeeName = employeeName
        
    }
}